module.exports = __webpack_public_path__ + "img/kw.35f1101e.svg";